import React from "react";
import { Checkbox, FormControl, FormControlLabel } from "@material-ui/core";
import { FieldAttributes, useField, useFormikContext } from "formik";

type UploadCheckboxProps = {
  label: string | React.ReactElement;
  fullWidth?: boolean;
} & FieldAttributes<{}>;

export const UploadCheckbox: React.FC<UploadCheckboxProps> = ({
  name,
  label,
  fullWidth,
}) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(name);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setFieldValue(name, checked);
  };

  const propsCheckBox = {
    ...field,
    checked: field.value,
    onChange: handleChange,
  };

  const propsFormControl = {
    fullWidth: fullWidth === undefined || fullWidth === true ? true : false,
  };

  return (
    <FormControl margin="normal" {...propsFormControl}>
      <FormControlLabel
        control={<Checkbox color="primary" size="small" {...propsCheckBox} />}
        label={label}
      />
    </FormControl>
  );
};
